import { Dog, Cat, Rabbit, Bird, Fish } from "lucide-react";

export const SPECIES = [
  { slug: "perro", name: "Perros", icon: Dog },
  { slug: "gato", name: "Gatos", icon: Cat },
  { slug: "conejos-roedores", name: "Conejos y roedores", icon: Rabbit },
  { slug: "aves", name: "Aves", icon: Bird },
  { slug: "peces", name: "Peces", icon: Fish },
];

export const CATEGORY_LABELS = {
  "alimento-y-snacks": "Alimento y snacks",
  "juguetes": "Juguetes",
  "accesorios": "Accesorios",
  "camas": "Camas",
  "transporte-y-otros": "Transporte y otros",
  "higiene-y-salud": "Higiene y salud",
  "grooming": "Grooming",
  "arena": "Arena",
  "rascadores": "Rascadores",
  "alimento-y-complementos": "Alimento y complementos",
  "jaulas": "Jaulas",
  "accesorios-para-jaulas": "Accesorios para jaulas",
  "higiene": "Higiene",
  "alimento": "Alimento",
  "accesorios-de-acuario": "Accesorios de acuario",
};

export const SPECIES_CATEGORIES = {
  perro: ["alimento-y-snacks", "juguetes", "accesorios", "camas", "transporte-y-otros", "higiene-y-salud", "grooming"],
  gato: ["arena", "rascadores", "juguetes", "grooming", "camas", "transporte-y-otros"],
  "conejos-roedores": ["alimento-y-complementos", "jaulas", "accesorios-para-jaulas", "higiene"],
  aves: ["alimento-y-complementos", "jaulas", "accesorios-para-jaulas", "juguetes", "higiene"],
  peces: ["alimento", "accesorios-de-acuario"],
};

export const catLabel = (slug) => CATEGORY_LABELS[slug] || slug;

// all unique category slugs (for admin fallback)
export const ALL_CATEGORIES = Array.from(new Set(Object.values(SPECIES_CATEGORIES).flat()));
